module.exports = __webpack_public_path__ + "img/sleeve_opening.2ef0ed78.png";